import { UserDataState } from "src/utils/redux/slices/userData";
import { appConfig } from "src/config";

const STAGING_URL = "https://b2b.test.wsli.dev/employer/carefirst/";
const PRODUCTION_URL = "https://go.noom.com/carefirst/";

export function getCareFirstRedirectUrl(
  userData: UserDataState,
  urlParams = new URLSearchParams(window.location.search)
) {
  const mixpanelId = userData.mixpanel_distinct_id || userData.user_id;
  const isProduction = appConfig.NOOM_ENV === "production";
  const baseURL = isProduction ? PRODUCTION_URL : STAGING_URL;

  urlParams.append("leadSource", "buyflow");
  if (mixpanelId) {
    urlParams.append("mpdid", mixpanelId);
  }
  if (!isProduction) {
    urlParams.append("passcode", "TESTCF");
  }
  return `${baseURL}?${urlParams.toString()}`;
}
